import React, {useState} from "react";
import {LocalDate, LocalDateTime} from "@js-joda/core";
import {DesktopDatePicker, DesktopDateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {CustomAdapter} from "../../../pages/dynamicforms/services/CustomAdapter";
import {BrowserView, MobileView} from "react-device-detect";
import {TextField} from "@mui/material";
import {TextFieldProps} from "@mui/material/TextField/TextField";

interface DatePickerProps {
	readonly inputFormat?: string;
	readonly label?: string;
	readonly value?: LocalDate | null;
	readonly onValueChange?: (value: LocalDate | null) => void;
	readonly placeholder?: string | null;
	readonly disabled?: boolean;
	readonly disableFuture?: boolean;
	readonly disablePast?: boolean;
	readonly variant?: "outlined" | "filled" | "standard";
	readonly textFieldProps?: TextFieldProps;
	
}

function isInvalidDate(text: string): boolean {
	if (text === "")
		return false;
	
	try {
		LocalDate.parse(text as string);
		return false;
	} catch {
		return true;
	}
}

// function DatePicker(props: DesktopDatePickerProps<LocalDateTime, LocalDateTime> & React.RefAttributes<HTMLDivElement>) {
export function DatePicker(props: DatePickerProps) {
	const [rawValue, setRawValue] = useState<string>("");
	const [value, setValue] = useState<LocalDateTime | null>(() => props.value?.atTime(0, 0) ?? null);
	return <LocalizationProvider dateAdapter={CustomAdapter}>
		<BrowserView>
			<DesktopDatePicker
				{...props}
				value={value}
				onChange={(event: LocalDate | LocalDateTime | Error | null) => {
					let eventValue = undefined;
					if (event instanceof LocalDate) {
						const newValue = event.atTime(0, 0);
						setValue(newValue);
						eventValue = event;
						setRawValue(eventValue.toString());
					} else if (event instanceof LocalDateTime) {
						setValue(event);
						eventValue = event.toLocalDate();
						setRawValue(eventValue.toString());
					} else if (event instanceof Error) {
						const match = event.message.match(/Text '([^']+)' could not be parsed/);
						if (match) {
							setRawValue(match[1]);
						}
					} else {
						setValue(null);
						eventValue = null;
						setRawValue("");
					}
					
					if (props.onValueChange && eventValue)
						props.onValueChange(eventValue);
				}}
				renderInput={(params) => <TextField
					{...params}
					{...props.textFieldProps}
					variant={props.variant}
					error={isInvalidDate(rawValue)}
					inputProps={{
						...params.inputProps,
						placeholder: props.placeholder ?? params.inputProps?.placeholder
					}}
				/>}
			/>
		</BrowserView>
		<MobileView>
			<>todo</>
		</MobileView>
	</LocalizationProvider>;
}

interface DateTimePickerProps {
	readonly inputFormat?: string;
	readonly label?: string;
	readonly value?: LocalDateTime | null;
	readonly onValueChange?: (value: LocalDateTime | null) => void;
	readonly placeholder?: string | null;
	readonly disabled?: boolean;
	readonly variant?: "outlined" | "filled" | "standard";
	readonly textFieldProps?: TextFieldProps;
}

function isInvalidDateTime(text: string): boolean {
	if (text === "")
		return false;
	
	try {
		LocalDateTime.parse(text as string);
		return false;
	} catch {
		return true;
	}
}

// function DateTimePicker(props: DesktopDateTimePickerProps<LocalDateTime, LocalDateTime> & React.RefAttributes<HTMLDivElement>) {
export function DateTimePicker(props: DateTimePickerProps) {
	const [rawValue, setRawValue] = useState<string>("");
	const [value, setValue] = useState<LocalDateTime | null>(() => props.value ?? null);
	return <LocalizationProvider dateAdapter={CustomAdapter}>
		<BrowserView>
			<DesktopDateTimePicker
				{...props}
				value={value}
				onChange={(event: LocalDate | LocalDateTime | Error | null) => {
					console.log(event);
					let eventValue = undefined;
					if (event instanceof LocalDate) {
						const newValue = event.atTime(0, 0);
						setValue(newValue);
						eventValue = newValue;
						setRawValue(eventValue.toString());
					} else if (event instanceof LocalDateTime) {
						setValue(event);
						eventValue = event;
						setRawValue(eventValue.toString());
					} else if (event instanceof Error) {
						const match = event.message.match(/Text '([^']+)' could not be parsed/);
						if (match) {
							setRawValue(match[1]);
						}
					} else {
						setValue(null);
						eventValue = null;
						setRawValue("");
					}

					console.log(eventValue);
					if (props.onValueChange && eventValue)
						props.onValueChange(eventValue);
				}}
				renderInput={(params) => <TextField
					{...params}
					{...props.textFieldProps}
					variant={props.variant}
					error={isInvalidDateTime(rawValue)}
					inputProps={{
						...params.inputProps,
						placeholder: props.placeholder ?? params.inputProps?.placeholder
					}}
				/>}
			/>
		</BrowserView>
		<MobileView>
			<>todo</>
		</MobileView>
	</LocalizationProvider>;
}
